import { render, staticRenderFns } from "./AdditionalQuestion.vue?vue&type=template&id=7aa31885&scoped=true"
import script from "./AdditionalQuestion.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestion.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQuestion.vue?vue&type=style&index=0&id=7aa31885&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa31885",
  null
  
)

export default component.exports